import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { StateResponse } from 'api/api';

import { useIpc } from '~src/utils/ipc-utils';

import { apiInstance, useGlobalState, useGlobalStateUpdate } from './../global-state';

export function usePurchaseCountryMutation() {
  const ipc = useIpc();
  const globalState = useGlobalState();
  const updateGlobalState = useGlobalStateUpdate();

  const mutationFn = async (newPurchaseCountry: string) => {
    const { data } = await apiInstance.v4.updatePurchaseCountry(globalState.checkout_session_id, {
      purchase_country: newPurchaseCountry,
    });
    return data;
  };

  return useMutation<StateResponse, AxiosError<{ message?: string }>, string>({
    mutationFn,
    mutationKey: ['purchase-country'],
    onSuccess: (newState: StateResponse) => {
      updateGlobalState(newState);

      ipc.send({
        name: 'country_changed',
        data: {
          purchase_country: newState.purchase_country,
        },
      });
    },
  });
}
